import React, { useState, useEffect } from "react";
import moment from "moment";
import DinamicModal from '../../components/dinamicModal/dinamicModal';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import Request from "../../core/httpClient";
import cogoToast from 'cogo-toast';
import styles from "./propietarioEditarModal.module.css";

const request = new Request();


function PropietarioEditarModal({ propietario, subLabel, escritura, closeModal, reload }) {
  // Estados
  const [idPersona, setIdPersona] = useState(propietario.id_persona || "");
  const [INombre, setINombre] = useState(propietario.nombre || "");
  const [IDireccion, setIDireccion] = useState(propietario.direccion || "");
  const [IMunicipio, setIMunicipio] = useState(propietario.municipio || "");
  const [IEstado, setIEstado] = useState(propietario.estado || "");
  const [ICp, setICp] = useState(propietario.cp || "");
  const [ITelefono, setITelefono] = useState(propietario.telefono || "");
  const [IPais, setIPais] = useState(propietario.pais || "");
  const [IGenero, setIGenero] = useState(propietario.genero || "");
  const [IId, setIId] = useState(propietario.tipo_identificacion || 0);
  const [INumId, setINumId] = useState(propietario.num_identificacion || "");
  const [IVigencia, setIVigencia] = useState(propietario.vigencia_identificacion || "");
  const [IFechaIngreso, setIFechaIngreso] = useState(
    propietario.fecha_entrada ? moment(propietario.fecha_entrada).format("YYYY-MM-DD") : ""
  );
  const [code, setCode] = useState(propietario.code || "");
  const [Iviv, setIviv] = useState(propietario.numero_registro || "");
  const [IIdViv, setIIdViv] = useState(propietario.id_vivienda || "");
  const [email, setEmail] = useState(propietario.email || "");
  const [citye, setCitye] = useState(propietario.ciudad || "");
  const [comentarios, setComentarios] = useState(propietario.comentarios || "");
  const [esResidente, setEsResidente] = useState(propietario.es_residente || false);

  const [loadingSave, setLoadingSave] = useState(false);
  const [telefonoError, setTelefonoError] = useState(undefined);

 
	const [pFechaCompra, setPFechaCompra] = useState(propietario.fecha_compra || "");
	const [pFechaVenta, setPFechaVenta] = useState(propietario.fecha_venta || "");

  
  useEffect(() => {
    setIdPersona(propietario.id_persona || "");
    setINombre(propietario.nombre || "");
    setIDireccion(propietario.direccion || "");
    setIMunicipio(propietario.municipio || "");
    setIEstado(propietario.estado || "");
    setICp(propietario.cp || "");
    setITelefono(propietario.telefono || "");
    setIPais(propietario.pais || "");
    setIGenero(propietario.genero || "");
    setIId(propietario.tipo_identificacion || 0);
    setINumId(propietario.num_identificacion || "");
    setIVigencia(propietario.vigencia_identificacion || "");
    setIFechaIngreso(
      propietario.fecha_entrada ? moment(propietario.fecha_entrada).format("YYYY-MM-DD") : ""
    );
    setCode(propietario.code || "");
    setIviv(propietario.numero_registro || "");
    setIIdViv(propietario.id_vivienda || "");
    setEmail(propietario.email || "");
    setCitye(propietario.ciudad || "");
    setComentarios(propietario.comentarios || "");
    setEsResidente(propietario.es_residente || false);
	setPFechaCompra(propietario.fecha_compra || "");
  	setPFechaVenta(propietario.fecha_venta || "");
  }, [propietario]);


  const handleClose = () => {
    closeModal();
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoadingSave(true);

    if (!isValidPhoneNumber(ITelefono)) {
      setTelefonoError("Número inválido");
      setLoadingSave(false);
      return;
    } else {
      setTelefonoError(undefined);
    }

    const resident = esResidente ? 1 : 0;

    const data = {
      idVivienda: IIdViv,
      Nombre: INombre,
      Direccion: IDireccion,
      Municipio: IMunicipio,
      Estado: IEstado,
      cp: ICp,
      Telefono: ITelefono,
      Pais: IPais,
      Genero: IGenero,
      TipoId: IId,
      NumId: INumId,
      Vigencia: IVigencia,
      FechaCompra: propietario.fecha_compra || "",
      FechaVenta: propietario.fecha_venta || "",
      Code: code,
      IdPersona: idPersona,
      email: email,
      idFraccionamiento: localStorage.getItem("frac") || 0,
      city: citye,
      comentarios: comentarios,
      id_usuario_upd: localStorage.getItem("user_id"),
      residente: resident,
    };

    const response = await request.post("/propietarios/update", data);

    if (response.updated && !response.empty) {
      reload();
      cogoToast.success("Datos del propietario actualizados.", {
        position: "bottom-right",
      });
    } else {
      cogoToast.error("No se pudieron actualizar datos del propietario.", {
        position: "bottom-right",
      });
    }

    setLoadingSave(false);
  };


  return (

  <DinamicModal
    idModal="editPropietario"
    sizeModalContainer="big"
    title="Editar propietario"
    success={handleSubmit}
    showBtnSuccess={escritura}
    btnTextSuccess="GUARDAR"
    showBtnCancel={true}
    btnTextCancel="CANCELAR"
    loadingSave={loadingSave}
    closeModal={handleClose}
  >

 <div className={`${styles.row} ${styles.inputFormContent}`}>
      <div className={`${styles.column} ${styles.labelMedium}`}>
        <p><b>{subLabel}:</b></p>
      </div>
      <div className={styles.column}>
        <input
          type="text"
          value={propietario.subname || ""}
          className="input input-modals"
          disabled
        />
      </div>
    </div>

    {/* Vivienda */}
    <div className={`${styles.row} ${styles.inputFormContent}`}>
      <div className={`${styles.column} ${styles.labelMedium}`}>
        <p><b>Vivienda:</b></p>
      </div>
      <div className={styles.column}>
        <input
          type="text"
          value={Iviv}
          onChange={(e) => setIviv(e.target.value)}
          className="input input-modals"
          disabled
          required
        />
      </div>
    </div>

    {/* Teléfono */}
    <div className={`${styles.row} ${styles.inputFormContent}`}>
      <div className={`${styles.column} ${styles.labelMedium}`}>
        <p><b>Teléfono:</b><b style={{ color: "red" }}> *</b></p>
      </div>
      <div className={styles.column}>
        <PhoneInput
          defaultCountry="MX"
          value={ITelefono}
          onChange={(value) => setITelefono(value)}
          error={telefonoError}
          disabled
          readOnly
        />
      </div>
    </div>

    {/* Nombre */}
    <div className={`${styles.row} ${styles.inputFormContent}`}>
      <div className={`${styles.column} ${styles.labelMedium}`}>
        <p><b>Nombre completo:</b><b style={{ color: "red" }}> *</b></p>
      </div>
      <div className={styles.column}>
        <input
          type="text"
          value={INombre}
          onChange={(e) => setINombre(e.target.value)}
          className="input input-modals"
          disabled
          required
        />
      </div>
    </div>
{/* Género y correo */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>Género:</b></p>
  </div>
  <div className={`${styles.column} ${styles.centeredColumn}`}>
    <select
      value={IGenero}
      onChange={(e) => setIGenero(e.target.value)}
      className="input input-modals"
      required
    >
      <option value="0">Hombre</option>
      <option value="1">Mujer</option>
      <option value="2">No especificado</option>
    </select>
  </div>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>Correo:</b></p>
  </div>
  <div className={`${styles.column} ${styles.centeredColumn}`}>
    <input
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      className="input input-modals"
    />
  </div>
</div>

{/* Identificación */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>Identificación:</b></p>
  </div>
  <div className={`${styles.column} ${styles.centeredColumn}`}>
    <select
      value={IId}
      onChange={(e) => setIId(e.target.value)}
      className="input input-modals"
    >
      <option value="0">INE</option>
      <option value="1">Pasaporte/Visa</option>
      <option value="2">Curp</option>
      <option value="3">Cartilla Militar</option>
    </select>
  </div>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>ID:</b></p>
  </div>
  <div className={`${styles.column} ${styles.centeredColumn}`}>
    <input
      type="text"
      value={INumId}
      onChange={(e) => setINumId(e.target.value)}
      className="input input-modals"
    />
  </div>
</div>



{/* Dirección */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>Dirección:</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="text"
      value={IDireccion}
      onChange={(e) => setIDireccion(e.target.value)}
      className="input input-modals"
    />
  </div>
</div>

{/* Municipio y Ciudad */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>Municipio:</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="text"
      value={IMunicipio}
      onChange={(e) => setIMunicipio(e.target.value)}
      className="input input-modals"
    />
  </div>
  <div className={`${styles.column} ${styles.labelDuoNormal}`}>
    <p><b>Ciudad:</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="text"
      value={citye}
      onChange={(e) => setCitye(e.target.value)}
      className="input input-modals"
    />
  </div>
</div>

{/* CP y Estado */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>C.P:</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="text"
      value={ICp}
      onChange={(e) => setICp(e.target.value)}
      className="input input-modals"
    />
  </div>
  <div className={`${styles.column} ${styles.labelDuoNormal}`}>
    <p><b>Estado:</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="text"
      value={IEstado}
      onChange={(e) => setIEstado(e.target.value)}
      className="input input-modals"
    />
  </div>
</div>

{/* País */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>País:</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="text"
      value={IPais}
      onChange={(e) => setIPais(e.target.value)}
      className="input input-modals"
    />
  </div>
</div>

{/* Fechas */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>Fecha de compra:</b><b style={{ color: "red" }}> *</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="date"
      value={pFechaCompra}
      onChange={(e) => setPFechaCompra(e.target.value)}
      className="input input-modals"
      required
    />
  </div>
  <div className={`${styles.column} ${styles.labelDuoNormal}`}>
    <p><b>Fecha de venta:</b></p>
  </div>
  <div className={styles.column}>
    <input
      type="date"
      value={pFechaVenta}
      onChange={(e) => setPFechaVenta(e.target.value)}
      className="input input-modals"
    />
  </div>
</div>

{/* Comentarios */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={`${styles.column} ${styles.labelMedium}`}>
    <p><b>Comentarios:</b></p>
  </div>
  <div className={styles.column}>
    <textarea
      value={comentarios}
      onChange={(e) => setComentarios(e.target.value)}
      rows="3"
      maxLength="500"
      className="textarea full"
    />
  </div>
</div>

{/* Estado residente */}
<div className={`${styles.row} ${styles.inputFormContent}`}>
  <div className={styles.column}>
    {esResidente ? (
      <span className={styles.statusSuccess}>
        <b>Es residente</b> <i className="fas fa-check"></i>
      </span>
    ) : (
      <span className={styles.statusError}><b>No es residente</b></span>
    )}
    
  </div>
</div>

{/* Nota */}
<div className={styles.note}>
  <small><b style={{ color: "red" }}> * </b> Indica un campo obligatorio</small>
</div>

  </DinamicModal>

	);
}

export default PropietarioEditarModal;

